module.exports = __webpack_public_path__ + "img/kommune-713.cf616197.svg";